// The backend base URL is injected at build time via REACT_APP_API_URL.
// CRA loads `.env.development` on `yarn start` and `.env.production` on `yarn build`.
// To target a local backend during development, create `.env.development.local`
// with REACT_APP_API_URL=http://localhost:8082 (gitignored).
const API = process.env.REACT_APP_API_URL;

if (!API) {
    throw new Error(
        '[env] REACT_APP_API_URL is not set. Define it in .env.development / .env.production ' +
        '(or .env.development.local to target a local backend).'
    );
}

// True only for the real production backend. Anything else (TEST = dev-api,
// local dev = localhost) is treated as non-prod so the test banner shows.
let isProd = false;
try {
    isProd = new URL(API).hostname === 'api.fitjo-app.link';
} catch {
    isProd = false;
}

export const Environment = {
    API,
    ENV: process.env.NODE_ENV,
    IS_PROD: isProd,
};
